import { useCallback, useEffect, useState } from 'react'

import { useMutation } from '@tanstack/react-query'

import { PRIVATE_ROUTES } from '../../Routes/routes'

import { listOfTalents } from '../../services/talents'

import ListOfCandidates from './ListOfTalents'

import DashboardWrapper from '../Dashboard/components/DashboardWrapper'
import { useForm } from 'react-hook-form'
import Wrapper from '../../components/Wrapper/Wrapper'
import InnerBanner from '../../components/InnerBanner'
import useGoToTop from '../../hooks/useGoToTop'
import useResize from '../../hooks/useResize'
import { OUT_OF_THE_APP, VIEWPORT_LG } from '../../utils/constants'
import Filters from './components/Filters'
import { userInfo } from '../../localStorage'
import { CANDIDATES_TAGS } from '../../services/Tags/candidates'
import FiltersModal from './components/FiltersModal'
import BannerIcon from '../../icons/landing/BannerIcon'

import {
  useListOfTalentsJuniorsStore,
  useListOfTalentsStore,
  useSearchTalentsFiltersJuniorsStore,
  useSearchTalentsFiltersStore,
} from '../../store'
import { useTranslation } from 'react-i18next'
import Divider from '../../components/Divider'
import ScheduleCallBanner from '../../components/ScheduleCallBanner/ScheduleCallBanner'
import hutrit_club_icon from '../../pages/HutritClub/icons/already_hutrit_club_member_company.svg'

const initialValues = {
  talentCategory: '',
  talentSkills: '',
  yearsExperience: [],
  keywords: '',
}

const Talents = ({ isJuniorView = false }) => {
  const { t } = useTranslation()

  const {
    data: globalData,
    page: globalPage,
    setData,
    setPage: setGlobalPage,
  } = useListOfTalentsStore()

  const {
    data: globalDataJunior,
    page: globalPageJunior,
    setData: setDataJunior,
    setPage: setGlobalPageJunior,
  } = useListOfTalentsJuniorsStore()

  const { payload = {} } = userInfo
  const { typeUser = 0 } = payload

  const {
    selectedCategories,
    selectedSkills,
    selectedLanguages,
    selectedExperience,
    selectedSectors,
    selectedCountries,
    selectedPromote,
    idioms,
    setFilterByWords,
    keywordGlobalValue,
  } = useSearchTalentsFiltersStore()

  const {
    selectedCategories: selectedCategoriesJuniors,
    selectedSkills: selectedSkillsJuniors,
    selectedLanguages: selectedLanguagesJuniors,
    selectedExperience: selectedExperienceJuniors,
    selectedSectors: selectedSectorsJuniors,
    selectedCountries: selectedCountriesJuniors,
    selectedPromote: selectedPromoteJuniors,
    idioms: selectedIdiomsJuniors,
    setFilterByWords: setFilterByWordsJuniors,
    keywordGlobalValue: keywordGlobalValueJuniors,
    filterUsernameOrEmail,
    setFilterUsernameOrEmail,
  } = useSearchTalentsFiltersJuniorsStore()

  const getOnlySkillsIds = isJuniorView
    ? selectedSkillsJuniors?.map(({ id }) => id)
    : selectedSkills?.map(({ id }) => id)
  const getOnlyCategoriesIds = isJuniorView
    ? selectedCategoriesJuniors?.map(({ id }) => id)
    : selectedCategories?.map(({ id }) => id)
  const getOnlyLanguagesIds = isJuniorView
    ? selectedLanguagesJuniors?.map(({ id }) => id)
    : selectedLanguages?.map(({ id }) => id)
  const getOnlyExperienceIds = isJuniorView
    ? selectedExperienceJuniors?.map(({ id }) => id)
    : selectedExperience?.map(({ id }) => id)
  const getOnlySectorIds = isJuniorView
    ? selectedSectorsJuniors?.map(({ id }) => id)
    : selectedSectors?.map(({ id }) => id)
  const getOnlyCountryIds = isJuniorView
    ? selectedCountriesJuniors?.map(({ id }) => id)
    : selectedCountries?.map(({ id }) => id)

  const [hasMore, setHasMore] = useState(true)
  const [selectedButton, setSelectedButton] = useState(2)
  const [scroll, setScroll] = useState(false)

  const { handleSubmit } = useForm(initialValues)

  const viewportSize = useResize()

  const handleNavigation = useCallback(() => {
    setScroll(!window.scrollY <= 0)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', handleNavigation)
    return () => {
      window.removeEventListener('scroll', handleNavigation)
    }
  }, [handleNavigation])

  const { mutate, isLoading: listOfTalentIsLoading } = useMutation(
    [CANDIDATES_TAGS.list_Of_Candidates_two, isJuniorView],
    listOfTalents,
    {
      onSuccess: (data) => {
        if (data?.length === 0 && globalPage > 0) {
          setHasMore(false)
        } else {
          setHasMore(true)
        }

        if (hasMore && data?.length > 0) {
          setData([...globalData, ...data])
          return
        }

        if (globalPage <= 0) {
          setData([...globalData, ...data])
          return
        }
      },
    }
  )

  const { mutate: mutateJuniors, isLoading: listOfTalentIsLoadingJuniors } =
    useMutation(['talents-juniors', isJuniorView], listOfTalents, {
      onSuccess: (data) => {
        if (data?.length === 0 && globalPageJunior > 0) {
          setHasMore(false)
        } else {
          setHasMore(true)
        }

        if (hasMore && data?.length > 0 && globalPageJunior > 0) {
          setDataJunior([...globalDataJunior, ...data])
          return
        }

         if (globalPageJunior === 0) {
          setDataJunior(data)
          return
        }
      },
    })

  const onSubmit = async () => {
    const defaultFilters = {
      filters: {
        yearsExperience:
          getOnlyExperienceIds?.length === 0 ? '' : getOnlyExperienceIds?.[0],
        talentSkills: getOnlySkillsIds,
        talentCategory:
          getOnlyCategoriesIds?.length === 0 ? '' : getOnlyCategoriesIds,
        countries: getOnlyCountryIds?.length === 0 ? [] : getOnlyCountryIds,
        sectors: getOnlySectorIds?.length === 0 ? [] : getOnlySectorIds,
        promote: selectedPromote,
        keywords: keywordGlobalValue,
        training: false,

        filterLang: idioms
          ? {
              langId: idioms?.value ?? 0,
              langLevelId: Number(getOnlyLanguagesIds?.[0]) ?? 0,
            }
          : null,
      },
      page: globalPage,
    }

    const juniorsFilters = {
      filters: {
        yearsExperience:
          getOnlyExperienceIds?.length === 0 ? '' : getOnlyExperienceIds?.[0],
        talentSkills: getOnlySkillsIds,
        talentCategory:
          getOnlyCategoriesIds?.length === 0 ? '' : getOnlyCategoriesIds,
        countries: getOnlyCountryIds?.length === 0 ? [] : getOnlyCountryIds,
        sectors: getOnlySectorIds?.length === 0 ? [] : getOnlySectorIds,
        promote: selectedPromoteJuniors,
        keywords: keywordGlobalValueJuniors,
        filterUsernameOrEmail,
        training: true,

        filterLang: selectedIdiomsJuniors
          ? {
              langId: selectedIdiomsJuniors?.value ?? 0,
              langLevelId: Number(getOnlyLanguagesIds?.[0]) ?? 0,
            }
          : null,
      },
      page: globalPageJunior,
    }
    isJuniorView ? mutateJuniors(juniorsFilters) : mutate(defaultFilters)
  }

  const handleGetMoreElements = () => {
    if (!hasMore) {
      return
    }

    if (hasMore) {
      if (window.location.pathname === PRIVATE_ROUTES.talents || isJuniorView) {
        isJuniorView
          ? setGlobalPageJunior(globalPageJunior + 1)
          : setGlobalPage(globalPage + 1)
      }
    }
  }

  if (window.location.pathname === PRIVATE_ROUTES.talents || isJuniorView) {
    useGoToTop()
  }

  return (
    <Wrapper
      activeWrapper={
        window.location.pathname === PRIVATE_ROUTES.talents && typeUser === 0
      }
    >
      <DashboardWrapper
        activeWrapper={
          (window.location.pathname === PRIVATE_ROUTES.talents ||
            isJuniorView) &&
          typeUser !== 0
        }
        dashboardWrapperClassName="w-100"
        hideDashboardWrapper
      >
        {/* TODO: refactor this component */}

        <form onSubmit={handleSubmit(onSubmit)}>
          <FiltersModal
            selectedButton={selectedButton}
            setSelectedButton={setSelectedButton}
            page={isJuniorView ? globalPageJunior : globalPage}
            setGlobalPage={isJuniorView ? setGlobalPageJunior : setGlobalPage}
            globalData={isJuniorView ? globalDataJunior : globalData}
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
            isJuniorView={isJuniorView}
          />
          <section
            id="list-of-talents"
            className={`${
              viewportSize[0] > VIEWPORT_LG
                ? 'd-flex flex-column align-items-center w-100'
                : ''
            } ${
              window.location.pathname === PRIVATE_ROUTES.talents ||
              isJuniorView
                ? viewportSize[0] > VIEWPORT_LG
                  ? 'pt-5 mt-5'
                  : 'p-2'
                : 'pt-0'
            }
          
          ${
            OUT_OF_THE_APP
              ? 'justify-content-center'
              : viewportSize[0] > VIEWPORT_LG
              ? 'p-5'
              : ''
          }
          `}
          >
            <div
              className={` 
             ${
               typeUser === 0
                 ? viewportSize[0] <= VIEWPORT_LG
                   ? ''
                   : 'w-75'
                 : 'w-100'
             }`}
            >
              {(window.location.pathname === PRIVATE_ROUTES.talents ||
                isJuniorView) &&
                typeUser === 0 && (
                  <InnerBanner
                    title={t('home')}
                    text={t('candidates')}
                    className={`d-flex ${
                      scroll ? 'mt-5 pt-3' : ''
                    } pb-3 ms-5 ps-1`}
                    beforeRoute={-1}
                  />
                )}
              {(window.location.pathname === PRIVATE_ROUTES.talents ||
                isJuniorView) &&
                OUT_OF_THE_APP && (
                  <div className="mb-5 d-flex justify-content-center align-items-center">
                    <BannerIcon
                      width={`${
                        viewportSize[0] <= VIEWPORT_LG ? '450' : '1040'
                      }`}
                      height={`${
                        viewportSize[0] <= VIEWPORT_LG ? '100' : '288'
                      }`}
                    />
                  </div>
                )}

              {typeUser !== 0 && (
                <div className="d-flex flex-lg-row flex-column align-items-lg-center gap-lg-5 mb-3">
                  <h1 className="text-on-bg-primary fw-bolder">
                    {isJuniorView ? `${t('talent')}` : t('talents')}
                  </h1>
                  {isJuniorView && (
                    <img
                      src={hutrit_club_icon}
                      width={viewportSize[0] <= VIEWPORT_LG ? 150 : 150}
                    />
                  )}
                </div>
              )}

              {typeUser !== 0 && (
                <Divider className="w-100 bg-on-bg-primary mb-4" />
              )}

              {typeUser !== 0 && <ScheduleCallBanner />}

              <Filters
                setSelectedButton={setSelectedButton}
                selectedCategories={
                  isJuniorView ? selectedCategoriesJuniors : selectedCategories
                }
                selectedSkills={
                  isJuniorView ? selectedSkillsJuniors : selectedSkills
                }
                selectedLanguages={
                  isJuniorView ? selectedLanguagesJuniors : selectedLanguages
                }
                selectedExperience={
                  isJuniorView ? selectedExperienceJuniors : selectedExperience
                }
                selectedSectors={
                  isJuniorView ? selectedSectorsJuniors : selectedSectors
                }
                selectedCountries={
                  isJuniorView ? selectedCountriesJuniors : selectedCountries
                }
                setFilterByWords={
                  isJuniorView ? setFilterByWordsJuniors : setFilterByWords
                }
                setFilterUsernameOrEmail={
                  isJuniorView ? setFilterUsernameOrEmail : setFilterUsernameOrEmail
                }
                setGlobalPage={
                  isJuniorView ? setGlobalPageJunior : setGlobalPage
                }
                setData={isJuniorView ? setDataJunior : setData}
                keywordGlobalValue={
                  isJuniorView ? keywordGlobalValueJuniors : keywordGlobalValue
                }
                isJuniorView={isJuniorView}
                selectedPromote={isJuniorView ? selectedPromoteJuniors : selectedPromote}
              />
            </div>
            <div
              className={`${
                viewportSize[0] <= VIEWPORT_LG ? 'p-1' : 'mt-5 w-100'
              } ${
                OUT_OF_THE_APP
                  ? viewportSize[0] <= VIEWPORT_LG
                    ? ''
                    : 'w-50'
                  : ''
              }`}
            >
              <div>
                <ListOfCandidates
                  data={isJuniorView ? globalDataJunior : globalData}
                  isLoading={
                    isJuniorView
                      ? listOfTalentIsLoadingJuniors
                      : listOfTalentIsLoading
                  }
                  handleGetMoreElements={handleGetMoreElements}
                  hasMore={hasMore}
                  listOfTalentsPage={
                    isJuniorView ? globalPageJunior : globalPage
                  }
                  page={isJuniorView ? globalPageJunior : globalPage}
                  selectedButton={selectedButton}
                  isJuniorView={isJuniorView}
                />
              </div>
            </div>
          </section>
        </form>
      </DashboardWrapper>
    </Wrapper>
  )
}

export default Talents
